import { createRouter, createWebHashHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import { Network } from '@capacitor/network';
import OfflineView from "../views/OfflineView.vue";
import { AgreementContent, } from "../use/useAgreementData";
import { useTouchpointsHTTP } from '../use/useTouchpointsHTTP';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import ('../views/HomeView.vue'),//HomeView,
    meta: {
      agreementCheck: true,
      needsAuth: true,
      showOnBar: false,
      needStartedDiary: true
    },
  },
  {
    path: "/question",
    name: "question",
    component: () => import ('../views/QuestionView.vue'),//QuestionView,
    meta: {
      agreementCheck: true,
      needsAuth: true,
      showOnBar: true,
      needStartedDiary: false
    },
  }, 
  {
    path: "/login",
    name: "login",
    component:  () => import ('../views/LoginView.vue'),//LoginView,
    meta: {
      showOnBar: false,
    },
  },
  {
    path: "/contactsupport",
    name: "contactsupport",
    component:  () => import ('../views/ContactSupport.vue'),//ContactSupportView,
    meta: {
      showOnBar: false,
    },
  },
  {
    path: "/welcome",
    name: "welcome",
    component:  () => import ('../views/WelcomeView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
    children: [
      {
        path: ':day_id',
        component: () => import ('../views/WelcomeView.vue')
      }
    ]
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component:  () => import ('../views/OnBoardingView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
  },
  {
    path: "/termsandconditions",
    name: "termsandconditions",
    component:  () => import ('../views/TermsAndConditionsView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component:  () => import ('../views/PrivacyView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
  },
  {
    path: "/training",
    name: "training",
    component:  () => import ('../views/TrainingView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
  },
  {
    path: "/sleeptask",
    name: "sleeptask",
    component:  () => import ('../views/SleepTaskView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
    },
  },
  {
    path: "/welcomeback",
    name: "welcomeback",
    component: () => import ('../views/WelcomeBackView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
      needStartedDiary: true,
      agreementCheck: true
    },
    children: [
      {
        path: "",
        name: "welcomeback_home",
        component: () => import ('../views/WelcomeBackHomeView.vue')
      },
      {
        path: 'day',
        name: "welcomeback_day",
        component: () => import ('../views/WelcomeBackDayView.vue'),
        meta: {
          needsAuth: true,
          showOnBar: false,
          needStartedDiary: true,
          agreementCheck: true
        },
        children: [
          {
            path: '0',
            name: "welcomeback_day1",
            component: () => import ('../views/WelcomeDay1.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '1',
            name: "welcomeback_day2",
            component: () => import ('../views/WelcomeDay2.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '2',
            name: "welcomeback_day3",
            component: () => import ('../views/WelcomeDay3.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '3',
            name: "welcomeback_day4",
            component: () => import ('../views/WelcomeDay4.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '4',
            name: "welcomeback_day5",
            component: () => import ('../views/WelcomeDay5.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '5',
            name: "welcomeback_day6",
            component: () => import ('../views/WelcomeDay6.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
          {
            path: '6',
            name: "welcomeback_day7",
            component: () => import ('../views/WelcomeDay7.vue'),
            meta: {
              needsAuth: true,
              showOnBar: false
            },
          },
        ]
      },
    ]
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import ('../views/NotificationsPage.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false,
      needStartedDiary: true,
      agreementCheck: true
    }
  },
  {
    path: "/adhoc",
    name: "adhoc",
    component: () => import ('../views/AdHocView.vue'),
    meta: {
      needsAuth: true,
      showOnBar: false
    }
  },
  {
    path: "/completing",
    name: "completing",
    component: () => import ('../views/CompletingView.vue'),
    meta: {
      needsAuth: false,
      showOnBar: false
    }
  },
  {
    path: "/offline",
    name: "offline",
    component: OfflineView,
    meta: {
      showOnBar: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component:  () => import ('../views/PageNotFoundView.vue'),//PageNotFound,
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

/*
  Authentication redirects
*/

router.beforeEach(async (to, from, next) => {
  /*
    Check Network Status
  */
  if(to.name !== 'offline')
  {
    const status = await Network.getStatus();
    if (status !== undefined)
    {
      if (status.connected === false)
     {
      next("/offline");
     }
    }
  }
  /*
    Check Auth
  */
  if (to.meta.needsAuth) {
    // Here we should send the token to the server and checked if we still are authenticated
    console.log("logged in")
    if (localStorage.getItem("touchPointsAuth") === "success") {
      if(to.meta.needStartedDiary === true) {
        console.log('needs started diary')
        const diaryStartDate = localStorage.getItem("diaryStartDate");
        let pastDiaryStartDate = false;
        if (diaryStartDate) {
          pastDiaryStartDate = new Date(diaryStartDate).getTime() <= Date.now();
        }
        if(pastDiaryStartDate) {
          console.log('diary started')
          if (to.meta.agreementCheck) {
            // check agreements are up to date and agreed to
            const TnCAgreed = localStorage.getItem("termAgree")  === 'true';
            const PrivacyAgreed = localStorage.getItem("privacyAgree") === 'true';
            const contentData = AgreementContent;
            const TnCVerUptoDate = localStorage.getItem("termVer") === contentData.term_ver;
            const PrivacyVerUptoDate = localStorage.getItem("privacyVer") === contentData.privacy_ver;

            if(TnCAgreed && PrivacyAgreed && TnCVerUptoDate && PrivacyVerUptoDate) {
              next();
            }
            else
            {
              // if not on onboarding page, redirect to onboarding page
              next('/onboarding');
            }
          }
          else {
            next();
          }
        }
        else {
          next('/onboarding');
        }
      }
      else {
        next();
      }
    } 
    else {
      next("/login");
    } 
  }
  else {
    next();
  }

  /*
    Rebuild summary when re-entering summary page
  */
});

/*
  Check Network Status On Change
*/

Network.addListener('networkStatusChange', (status:any) => {
  console.log('Network status changed', status);
  if (status !== undefined)
  {
   if (status.connected === false)
   {
    router.push({ name: "offline" });
   } else {
    if (router.currentRoute.value.name === "offline") {
      useTouchpointsHTTP().count_reconnections(localStorage.getItem("username")!);
      router.go(-1);
    }
   }
  }
});

const currentNetworkStatus = async () => {
  const status = await Network.getStatus();
  if (status !== undefined)
  {
    if (status.connected === false)
   {
    router.push({ name: "offline" });
   }
  }
};

currentNetworkStatus();


export default router;
